import { useEffect, useRef, useState } from "react";
import { createRoot } from "react-dom/client";
import tippy from "tippy.js";
import "tippy.js/dist/tippy.css";
import "tippy.js/animations/shift-away.css";
import css from "./Tutorial.module.scss";
import { getUrlParam } from "@/js/functions";
import { useLiveStore } from "@/template/live/_store";

const Tutorial = () => {
  const cookieKey = "doneTutorial";
  const padding = 4;
  const [index, setindex] = useState();
  const [contentRect, setcontentRect] = useState(null);
  const [finished, setfinished] = useState(false);
  const [showModal, setshowModal] = useState(false);
  const { questionStatus, activeSession } = useLiveStore();
  const doneTutorialRef = useRef(false);
  const timerRef = useRef();
  const tippyArr = useRef([]);

  const data = [
    {
      id: "meetingSelect",
      content: "ご参加の会場を選んでください",
      placement: "bottom",
    },
    {
      id: "hbg",
      content: "ニックネームの変更やクイズの成績表などのメニューを開きます",
      placement: "bottom",
    },
    {
      id: "commentForm",
      content: "是非コメントを投稿してください！",
      placement: "bottom",
    },
    {
      id: "timeTable",
      content: "番組表を開きます",
      placement: "top",
      highlightStyle: {
        borderRadius: "50%",
      },
    },
  ];

  // bodyのスクロール可否トグル
  useEffect(() => {
    if (showModal) {
      document.body.classList.add("scrollHidden");
      tippyArr.current[index]?.show();
    } else {
      document.body.classList.remove("scrollHidden");
      tippyArr.current.forEach((obj) => {
        obj.hide();
      });
    }
  }, [showModal]);

  // 初回のtippyをセット
  useEffect(() => {
    if (activeSession?.status === 0) return;
    createTippyArr();
  }, [activeSession]);

  useEffect(() => {
    if (
      activeSession === undefined ||
      activeSession?.status === 0 ||
      questionStatus?.activeQuiz ||
      doneTutorialRef.current
    ) {
      clearTimeout(timerRef.current);
      setshowModal(false);
      return;
    }

    let userInfo = getSympoUserInfo(getUrlParam(0));

    const main = async () => {
      doneTutorialRef.current = localStorage.getItem(cookieKey);

      if (!userInfo || !cookieChecker() || doneTutorialRef.current) {
        return;
      }

      const startTutorial = () => {
        setshowModal(true);
        document.body.classList.add("scrollHidden");
        setindex((prev) => {
          if (prev === undefined) return 0;
          return prev;
        });
      };

      timerRef.current = setTimeout(startTutorial, 2000);
    };

    main();
  }, [activeSession, questionStatus]);

  useEffect(() => {
    // console.log(document.querySelectorAll(".c-Tutorial__nextBtn"));

    // 次へボタンのイベントを設定
    setTimeout(() => {
      document
        .querySelectorAll(".c-Tutorial__nextBtn")
        .forEach((nextBtn, i) => {
          nextBtn.onclick = () => {
            // console.log("nextBtn", {
            //   arr: tippyArr.current,
            //   item: tippyArr.current[i],
            //   index: i,
            // });
            tippyArr.current[i].hide();
            setindex((prev) => prev + 1);
          };
        });
    }, 100);

    // 対象の要素の座標と大きさを取得
    if (index !== undefined && tippyArr.current[index]) {
      setcontentRect(tippyArr.current[index].reference.getBoundingClientRect());
      tippyArr.current[index].show();
    }

    // 終了時の処理
    if (index > 0 && index === tippyArr.current?.length) {
      setfinished(true);
    }
  }, [index]);

  // 終了後のイベント
  useEffect(() => {
    if (finished) {
      setshowModal(false);
      localStorage.setItem(cookieKey, "1");
    }
  }, [finished]);

  const onFinished = () => {
    if (index !== tippyArr.current?.length) {
      setindex(tippyArr.current?.length);
    }
    setfinished(true);
  };

  const createTippyArr = () => {
    // console.log("set tippy", activeSession);

    tippyArr.current = [];
    data.forEach((obj) => {
      const selector = `[data-tippy-id="${obj.id}"]`;

      // 要素があるかつ表示されている場合
      if (
        document.querySelector(selector) &&
        document.defaultView.getComputedStyle(
          document.querySelector(selector),
          null
        ).display !== "none"
      ) {
        const instance = tippy(selector, {
          // onClickOutside(instance, event) {
          //   setindex((prev) => prev + 1);
          // },

          content: `
            <div class="c-Tutorial__tippy">
              <p>${obj.content}</p>
              <button class="c-Tutorial__nextBtn">次へ</button>
            </div>`,
          allowHTML: true,
          animation: "shift-away",
          hideOnClick: false,
          placement: obj.placement,
          theme: "mainTheme",
          trigger: "manual",
          zIndex: 999999,
          maxWidth: window.innerWidth * (2 / 3),
          offset: [
            0,
            obj.placement === "top"
              ? window.innerHeight - document.documentElement.clientHeight + 20
              : 10 + padding,
          ],
        });

        tippyArr.current.push(instance[0]);
      }
    });
  };

  return (
    <div
      data-testid="tutorialLayer"
      className={`${css["layer"]} ${!showModal && css["hidden"]}`}
      onClick={onFinished}
    >
      {/* <FloatingPortal id="hbgWrap">
        <div onClick={test}>Floating element</div>
      </FloatingPortal> */}
      <button className={`${css["close"]}`}>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          height="24"
          viewBox="0 -960 960 960"
          width="24"
        >
          <path
            d="m336-280 144-144 144 144 56-56-144-144 144-144-56-56-144 144-144-144-56 56 144 144-144 144 56 56ZM480-80q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm0-80q134 0 227-93t93-227q0-134-93-227t-227-93q-134 0-227 93t-93 227q0 134 93 227t227 93Zm0-320Z"
            fill="#fff"
          />
        </svg>
      </button>

      {contentRect && (
        <>
          <div
            className={css["block"]}
            style={{
              height: contentRect.y,
            }}
          ></div>
          <div className={`${css["row"]}`}>
            <div
              className={css["block"]}
              style={{
                width: contentRect.x,
              }}
            ></div>
            <div
              style={{
                width: contentRect.width,
                height: contentRect.height,
              }}
            >
              <div
                className={`${css["main"]}`}
                style={{
                  ...data[index]?.highlightStyle,
                }}
              ></div>
            </div>
            <div className={`${css["block"]} ${css["flexBlock"]}`}></div>
          </div>
          <div className={`${css["block"]} ${css["flexBlock"]}`}></div>
        </>
      )}
    </div>
  );
};

function cookieChecker() {
  let tmp = false;
  let cookiesArray = document.cookie.split(";");
  for (var c of cookiesArray) {
    //一つ一つ取り出して
    let cArray = c.split("="); //さらに=で分割して配列に
    if (cArray[0].trim() == "symposiumId") {
      // 取り出したいkeyと合致したら
      if (cArray[1].trim().split(",").includes(getUrlParam(0))) {
        tmp = true;
      }
    }
  }
  return tmp;
}

export default Tutorial;
